var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{staticClass:"status-chip",class:['elevation-1'],attrs:{"color":_vm.getStatusColor(_vm.value),"text-color":_vm.getStatusTextColor(_vm.value),"small":""}},[_vm._v(_vm._s(_vm.getStatusText(_vm.value)))])}
var staticRenderFns = []

export { render, staticRenderFns }